/**
 * Removes the last n characters from a string
 * @param {string} string string of characters
 * @param {number} number number of characters to remove
 * @returns string
 */
const removeLastNChars = (string: string, number: number): string => string.slice(0, -number);

export default removeLastNChars;